import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import styled from 'styled-components'

const TourDarkSuccessPromotionLabel = styled(PromotionLabel)`
  &&&.kind-tertiary.variant-highlight {
    background-color: ${props => props.theme.palette.messaging.success.darkBackground};
    border-color: ${props => props.theme.palette.messaging.success.darkForeground};
    color: ${props => props.theme.palette.messaging.success.darkContrast};
  }

  &&&.kind-tertiary.variant-highlight > svg,
  &&&.kind-tertiary.variant-highlight > * {
    color: ${props => props.theme.palette.messaging.success.darkContrast};
  }
`

export default TourDarkSuccessPromotionLabel
